import { css } from 'styled-components';
export const sizes = {
    hd: 1200,
    //wide: 992,
    desktop: 992,
    tablet: 768,
    mobileLarge: 576,
    mobileLandscape: 360,
};
export const screenSizes = label => `${sizes[label] / 16}em`;
const generateTemplates = (source) => Object.keys(source).reduce((result, label) => {
    // use em in breakpoints to work properly cross-browser and support users
    // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
    result[label] = (arg1, ...args) => css `
      @media (min-width: ${screenSizes(label)}) {
        ${css(arg1, ...args)};
      }
    `;
    return result;
}, {});
// iterate through the sizes and create a media template
export const media = generateTemplates(sizes);
//# sourceMappingURL=media.js.map